import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/reset.css'
Vue.config.productionTip = false
// 引入flexible
import 'lib-flexible/flexible'

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
